import { DEFAULT_REFERRAL_USES_PER_USER, DEFAULT_REFERRAL_VALUE, DEFAULT_REFERRER_VALUE } from 'common/Constants';
import { ClientEvents } from 'common/events/ClientEvents';
import { getReferralCodeTitle } from 'common/ReferTextUtilities';
import { QueryParams } from 'common/urls/QueryParams';
import QueryString from 'query-string';
import React, { useCallback } from 'react';
import MoneyEnvelope from 'src/assets/svg/money_envelope.svg';
import { FaAngleRight } from 'src/shared/design-system/FontAwesome';
import { useCurrentUser } from 'src/shared/hooks/useCurrentUserHook';
import { useLocation } from 'src/shared/hooks/useLocation';
import { useTracker } from 'src/shared/hooks/useTracker';
import { Routes } from 'src/shared/Routes';
import { getRegisterRedirect } from 'src/shared/utils/RouteUtilities';
import { MiniBanner } from '../components/MiniBanner';
import { Container, Header, SpacerDiv, Wrapper } from './styles';

export const useReferralBanner = () => {
  const [currentUser, loading] = useCurrentUser();

  const tracker = useTracker();
  const location = useLocation();
  const parsedQs = QueryString.parse(location.search);
  const esid = parsedQs[QueryParams.EXPLORE_SEGMENT_ID];

  const onClick = useCallback(() => {
    tracker.track(ClientEvents.EXPLORE_SEGMENT_C2C_REFER_CLICK, { esid });
  }, [esid, tracker]);

  const defaultReferralCode = {
    giveValue: DEFAULT_REFERRAL_VALUE,
    getValue: DEFAULT_REFERRER_VALUE,
    maxUsesPerUser: DEFAULT_REFERRAL_USES_PER_USER,
  };

  const referralCode = currentUser ? currentUser.referralCode : defaultReferralCode;

  const isSignedOut = !loading && !currentUser;
  const referralCodeTitle = getReferralCodeTitle({ referralCode });

  const toUrl = isSignedOut
    ? getRegisterRedirect({ url: Routes.CONSUMER_ACCOUNT_SHARE })
    : Routes.CONSUMER_ACCOUNT_SHARE;

  return { toUrl, loading, referralCodeTitle, onClick };
};

export const ReferralBanner = () => {
  const { loading, toUrl, referralCodeTitle, onClick } = useReferralBanner();

  if (loading) return null;

  return (
    <Container to={toUrl} onClick={onClick}>
      <Wrapper>
        <SpacerDiv />
        <div>
          <Header>{referralCodeTitle}</Header>
          Learn more <FaAngleRight />
        </div>
        <img src={MoneyEnvelope} className='ml-4 size-16 object-contain' />
      </Wrapper>
    </Container>
  );
};

export const MiniReferralBanner: React.FC<{ className?: string }> = ({ className }) => {
  const { loading, toUrl, referralCodeTitle, onClick } = useReferralBanner();

  if (loading) return null;

  return (
    <MiniBanner
      className={className}
      bgColorClassName='bg-mint-100'
      mainText={referralCodeTitle}
      ctaText='Learn more'
      ctaTo={toUrl}
      ctaClick={onClick}
      graphic={<img src={MoneyEnvelope} className='mb-4 mr-4 size-20 object-contain md:size-24' />}
    />
  );
};
